window.toggleSearch = function(button) {
    let classicSearch = document.querySelector('.js-classic-search');
    let advancedSearch = document.querySelector('.js-advanced-search');

    if(classicSearch.classList.contains('hidden')) {
        classicSearch.classList.remove('hidden');
        advancedSearch.classList.add('hidden');

        button.innerHTML = "Rozšířené vyhledávání";
    }
    else {
        classicSearch.classList.add('hidden');
        advancedSearch.classList.remove('hidden');

        button.innerHTML = "Skrýt rozšířené vyhledávání";
    }
};


window.changeDate = function(node) {
    if(node.value) {
        let clearButton = node.parentElement.querySelector('.js-clear-input');
        clearButton.disabled = false;
    }
}

window.clearInput = function(node) {
    if(node.disabled) {
        return;
    }
    
    node.parentElement.querySelector('input').value = '';
    node.disabled = true;
}



window.App.ClearSearchResults = {
    _searchInputs: [],

    init() {
        if(! document.querySelectorAll('.js-search-results-input')) {
            return;
        }
        let searchInputs = document.querySelectorAll('.js-search-input');

        searchInputs.forEach(searchInput => {

            searchInput._inputEnterEvtRef = this._reload.bind(this);
            searchInput.addEventListener('input', searchInput._inputEnterEvtRef, false);
            this._searchInputs.push(searchInput);
        });

    },

    reInit() {
        this._searchInputs.forEach(searchInput => {
           searchInput.removeEventListener('input', searchInput._inputEnterEvtRef, false);
        });

        this.init();
    },

    _reload() {
        if(event.currentTarget.value === "") {
            this.closest('form').submit();
        }
    }
};

window.App.ClearSearchResults.init();
document.addEventListener('LokiRequestEnd', function () {
    window.App.ClearSearchResults.reInit();
});